/** When true: landing uses free-forever copy, hides paid pricing UI, and FAQ route is disabled. */
export const FREE_MODE_ENABLED = true;
